import { NOTIFICATIONS_POPOVER } from './popover';
import { NOTIFICATIONS_TABLE } from './table';
export const NOTIFICATIONS_TRANSLATIONS = {
    ...NOTIFICATIONS_TABLE,
    ...NOTIFICATIONS_POPOVER
};
